import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

function ChartRenderer({ dataLineChart, lables }) {
  const toPersianDigits = (str) => {
    if (!str) return "";
    return str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  };
  const chartFormatter = new Intl.NumberFormat("fa-IR");

  return (
    <>
      <ResponsiveContainer width="100%" minHeight={"18rem"}>
        <LineChart
          width={"auto"}
          height={"17.5rem"}
          data={dataLineChart}
          margin={{
            top: 5,
            right: 10,
            left: 0,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            fontSize={"10px"}
            angle={10}
            tickMargin={10}
            tickFormatter={(value) => chartFormatter.format(value)}
          />
          <YAxis
            tickMargin={40}
            fontSize={"13px"}
            tickFormatter={(value) => chartFormatter.format(value)}
          />
          <Tooltip
            content={({ active, payload }) => {
              if (active && payload && payload.length) {
                const colors = [
                  "#3592FB",
                  "rgba(154, 64, 224, 1)",
                  "rgba(255, 152, 0, 1)",
                ];

                return (
                  <Box
                    sx={{
                      background: "#fff",
                      p: 1.5,
                      border: "1px solid #ccc",
                      borderRadius: 2,
                    }}
                  >
                    {payload.map((entry, i) => (
                      <Typography
                        key={i}
                        variant="body2"
                        sx={{
                          color: colors[i] || "#000",
                          fontWeight: 500,
                          mb: 0.5,
                        }}
                      >
                        {entry.name} : {toPersianDigits(entry.value)}
                      </Typography>
                    ))}
                  </Box>
                );
              }
              return null;
            }}
          />
          <Line
            type="monotone"
            name={lables.date1}
            dataKey="value"
            stroke="#3592FB"
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            name={lables.date2}
            dataKey="value1"
            stroke="rgba(154, 64, 224, 1)"
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            name={lables.date3}
            dataKey="value2"
            stroke="rgba(255, 152, 0, 1)"
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </>
  );
}

export default ChartRenderer;
